import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAsyncEffect } from 'rooks';
import { safeChangeLanguage } from '@/utilities/i18n.utilities';
import type { LocaleKey } from '@/utilities/i18n.constants';

export const LocalisationWrapper = () => {
  useAsyncEffect(async () => {
    const preferredLocale = localStorage.getItem('seeq_preferred_locale') as LocaleKey | null;
    const cleanup = await safeChangeLanguage(preferredLocale);
    return () => {
      cleanup?.();
    };
  }, []);

  return <Outlet />;
};
